import React from "react";
import { Button } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

import { StyledModal } from "../DeclarationSubmitConfirmation/styledComponents";

export interface DeclarationApprovalResetConfirmationProps {
  loading: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/*
 * Shown when an operator puts a declaration back in front of the customer while
 * the customer's earlier approval is still on record. The status change and the
 * reset happen together, so cancelling here cancels both.
 */
const DeclarationApprovalResetConfirmation = ({
  loading,
  onConfirm,
  onCancel,
}: DeclarationApprovalResetConfirmationProps) => (
  <StyledModal
    visible
    title={
      <div>
        <ExclamationCircleOutlined
          style={{ fontSize: "28px", color: "var(--purple)" }}
        />
        <p>Bisherige Kundenfreigabe wird zurückgesetzt</p>
      </div>
    }
    onOk={onConfirm}
    onCancel={onCancel}
    footer={[
      <Button key="Abbrechen" onClick={onCancel}>
        Abbrechen
      </Button>,
      <Button
        key="ErneutZurFreigabe"
        type="primary"
        loading={loading}
        onClick={onConfirm}
        data-test="confirmApprovalResetButton"
      >
        Erneut zur Freigabe geben
      </Button>,
    ]}
    width={460}
    style={{ top: 130 }}
  >
    <p>
      Der Kunde hat diese Erklärung schon einmal freigegeben. Mit dem Status
      "Warten auf Kundenfreigabe" wird die bisherige Freigabe zurückgesetzt, und
      der Kunde kann die überarbeitete Erklärung neu freigeben.
    </p>
    <p>Eine Benachrichtigung an den Kunden geht dabei nicht raus.</p>
  </StyledModal>
);

export default DeclarationApprovalResetConfirmation;
